import { __awaiter } from "tslib";
import { Router } from '../router/Router';
import { Renderer } from '../renderer/Renderer';
export class Chassi {
    constructor(options) {
        this.options = options;
        this.renderer = new Renderer(this.options.getRootElement());
    }
    run() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.prepareRoutes(this.options.routes).then(this.init.bind(this));
        });
    }
    prepareRoutes(routesParam) {
        return __awaiter(this, void 0, void 0, function* () {
            let routes;
            if (typeof routesParam === 'function') {
                routes = yield routesParam();
            }
            else {
                routes = routesParam;
            }
            this.routerConfig = new Router(routes, this.renderer);
            return routes;
        });
    }
    init() {
        this.invokeHook('onCreate');
        this.startRouter();
    }
    startRouter() {
        this.routerConfig.listen(this.onRouteChange.bind(this));
        this.routerConfig.configRouter();
        this.routerConfig.start();
    }
    onRouteChange(location) {
        if (this.options.onRouteChange) {
            this.options.onRouteChange(location);
        }
        this.invokeHook('onRouteChange');
    }
    invokeHook(hookName) {
        if (this.options[hookName]) {
            this.options[hookName]();
        }
    }
}
